import { useApolloClient } from "@apollo/client";
import { useGraphqlFetchAndCache } from "@mostrans/web-components/hooks/useGraphqlFetchAndCache";
import { getEmployeeDemographyAdmin } from "../DemographyQueries";
import { EmployeeDemographyAdminAtom } from "../DemographyAtoms";

export const useGetEmployeeDemographyAdmin = () => {
  const client = useApolloClient();
  return useGraphqlFetchAndCache({
    atom: EmployeeDemographyAdminAtom,
    initialValue: [],
    getData: (param) => getEmployeeDemographyAdmin(client, param),
    variables: {},
  });
};
